import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { ResortTypeCard } from 'entities/tour/ui'

import s from './styles.module.scss'

export interface FilterSelectorOption {
  value: string
  label: string | ReactNode
}

interface FilterSelectorProps {
  title: string
  selected: string[]
  options: FilterSelectorOption[]
  onChange: (values: string[]) => void
  hasAll?: boolean
}

export const FilterSelector = ({
  title,
  selected,
  options,
  onChange,
  hasAll = false,
}: FilterSelectorProps) => {
  const { t } = useTranslation()

  const handleSelect = (value: string) => {
    const isSelected = selected.includes(value)

    if (isSelected) {
      onChange(selected.filter((v) => v !== value))
    } else {
      const newSelection = [...selected, value]
      onChange(newSelection)
    }
  }

  if (!options?.length) return null

  const handleSelectAll = () => {
    onChange([])
  }

  return (
    <div className={s.filterSelector}>
      <p className={clsx('bold-18', s.filterSelectorTitle)}>{t(title)}</p>
      <div className={s.filterSelectorList}>
        {hasAll && (
          <ResortTypeCard
            key="all"
            name={t('tours_block.any')}
            isActive={selected.length === 0}
            onClick={handleSelectAll}
            className={s.filterSelectorItem}
          />
        )}

        {options.map((option) => (
          <ResortTypeCard
            key={option.value}
            name={option.label}
            isActive={selected.includes(option.value)}
            onClick={() => handleSelect(option.value)}
            className={s.filterSelectorItem}
          />
        ))}
      </div>
    </div>
  )
}
